import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import { DjelatniciService } from './djelatnici.service';

@Component({
  selector: 'app-djelatnici',
  templateUrl: './djelatnikPrava.html',
  styleUrls: ['./djelatnici.component.scss'],
  providers: [DjelatniciService],
})
export class djelatnikPravaComponent implements OnInit {
  
  idfirma: any;
  idSecUser: any; //PRIJAVLJENI KORISNIK
  sveGrupe: any = []; //LJUDSKI RESURSI, LJUDSKI RESURSI ADMIN, AKCIJA, AKCIJA ADMIN...
  idGrupa: any; //ID OD ODABRANE GRUPE iz sveGrupe
  sviModuli: any = []; //RASPORED LJUDI, DJELATNICI, GODIŠNJI ITD...

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: DjelatniciService, private router: Router) {
    this.idfirma = localStorage.getItem('firma');
    this.idSecUser = localStorage.getItem('idsecuser');
    this.dohvatiGrupeDjelatnika();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().djelatnikPrava;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  dohvatiGrupeDjelatnika() {
    this.service
      .dohvatiGrupeDjelatnika({ idkorisnik: this.idSecUser, idfirma: this.idfirma })
      .subscribe((res) => {
        console.log(res);

        if (res.success === true) {
          this.sveGrupe = res.data;
        } else this.sveGrupe = [];
      });
  }

  backButtonClicked() {
    this.router.navigate(['/djelatnici']);
  }

  ngOnInit() {}

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  //ODABIR GRUPE KORISNIKA
  odabranaGrupa(data: any) {
    console.log(data);
    this.idGrupa = data.value;
    this.dohvatiPrava();
  }

  //DOHVAĆANJE PRAVA ZA ODABRANU GRUPU
  dohvatiPrava() {
    this.service.grupeModulPrava({ idkorisnik: this.idSecUser, idfirma: this.idfirma, idgrupa: this.idGrupa }).subscribe((res) => {
      console.log(res);
      this.sviModuli = [];

      if (res.success === true) {
        this.sviModuli = res.data;
      } else {
        this.sviModuli = [];
      }
    });
  }

  //MIJENJANJE PRAVA PREKO CHECKBOXA
  promjeniPrava(e: any, data: any, prava: any) {
    console.log('data: ', data);
    console.log('e:  ', e.value);
    console.log('prava: ', prava);
    this.service
      .pravaUpdate({
        idgrupa: data.data.idgrupa,
        idmodul: data.data.idmodul,
        gm_prava: prava,
      })
      .subscribe((res) => {
        console.log(res);

        this.dohvatiPrava();
      });
  }
}
